import React, { useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { CircularProgress, TextField } from "@mui/material";
import toast, { Toaster } from "react-hot-toast";

export default function Asynchronous(props) {
  const {
    getOptionLabel,
    Service,
    value,
    inputProps,
    variant,
    searchBy,
    stockValidate,
    ...rest
  } = props;

  const [inputValue, setInputValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const handleInputValueChange = (e, newValue) => {
    setInputValue(newValue);
    newValue.length > 0 ? setLoading(true) : setOptions([]);
    // if (e.key === 'Enter') {
    //   newValue.length >= 3 &&
    //     newValue.length <= 12 &&
    //     (async () => {
    //       const response = await Service(newValue);
    //       setOptions(response);
    //       setLoading(false);
    //     })();
    // }
  };
  const handleKeyDown = (e) => {
  if (e.key === "Enter") {
    (async () => {
      setLoading(true);
      try {
        const response = await Service(e.target.value, searchBy);

        if (!response || response.length === 0) {
          toast.error("ITEM NOT FOUND!");
          return;
        }

        if (stockValidate) {
          const FilteredStock = response.filter(
            (row) => row.remainingQuantity > 0
          );

          let FilteredZeroStock = [];

            if (response.length === 1) {
              FilteredZeroStock = response.filter(
                (row) => row.remainingQuantity == 0
              );
            }

          if (FilteredZeroStock.length == 1) {
            toast.error("ITEM STOCK IS 0!");
          }
          else if (FilteredStock.length === 0) {
            toast.error("ITEM NOT IN STOCK!");
          } else {
            setOptions(FilteredStock);
          }
          
        } else {
          setOptions(response);
        }
      } catch (error) {
        console.error("Error fetching items:", error);
        toast.error(error.message || "Something went wrong!");
      } finally {
        setLoading(false);
      }
    })();
  }
};

  useEffect(() => {
    open && options.length === 0 && setLoading(true);
  }, [open, options.length]);

  return (
    <React.Fragment>
      <Toaster position="top-center" reverseOrder={false} />
      <Autocomplete
        autoHighlight
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        onOpen={() => {
          setOpen(true);
        }}
        clearOnEscape
        value={value === "" ? null : value}
        getOptionLabel={
          getOptionLabel
            ? getOptionLabel
            : (option) => option.name + " | " + option.barcode
        }
        {...rest}
        options={options}
        loading={loading}
        inputValue={inputValue}
        onInputChange={handleInputValueChange}
        onKeyDown={options.length == 0 && handleKeyDown}
        renderInput={(params) => (
          <TextField
            {...params}
            {...inputProps}
            variant={variant ? variant : "outlined"}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading && open ? (
                    <CircularProgress color="inherit" size={15} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </React.Fragment>
  );
}
